import { auth } from './auth';
import { qna } from './content/qna';
import { share } from './content/share';
import { chats } from './content/chats';
import { tabs } from './content/tabs';

/**
 * Centralized services object that exports all API services
 * This allows for consistent access to API functionality throughout the application
 */
export const services = {
  /** Authentication services */
  auth,
  /** Question and answer services */
  qna,
  /** Content sharing services */
  share,
  /** Chat management services */
  chats,
  /** Tab management services */
  tabs,
};
